function promotionalPrice(rawPrice, percent, fixedSaving) {
  return Math.max(0, rawPrice - Math.floor(rawPrice * percent / 100) - (fixedSaving || 0));
}

function confirmMattressChoice($input) {
  $input = $input.first();
  if (!$input.length || !$input.val() || $input.prop('disabled')) return;
  var $label = $input.closest('label');
  var $content = $label.clone();
  $content.find('input').remove();
  var $remove = $content.find('.remove-selection').removeAttr('hidden').detach();
  var removeHtml = $remove.length ? $remove.prop('outerHTML') : '';
  $('.mattress-add-on.selected').html('<strong class="lmb-mattress-selected-label">✓ Mattress Selected</strong><div class="lmb-mattress-selected-product">' + $content.html() + '</div><div class="lmb-mattress-selected-actions">' + removeHtml + '<button type="button" class="lmb-mattress-change" data-dilog="mattress-pop">Change Mattress</button></div>').attr({
    'aria-live': 'polite',
    'data-variant-id': $input.val(),
    'data-price': $input.attr('data-price') || 0,
    'data-promo-percent': $input.attr('data-promo-percent') || 0,
    'data-mattress-handle': $label.attr('data-mattress-handle')
  }).show();
  $('.mattress-add-on.selection').hide();
  $('#mattress-pop .lmb-mattress-selection-status').text('Selected: ' + $label.find('h4').text());
  $('#mattress-pop .btn-mattress-cart').prop('disabled', false).text($('#mattress-pop').attr('data-confirm-label'));
}

function clearMattressChoice() {
  $('.mattress-add-on.selected').hide().empty().removeAttr('data-variant-id data-price data-promo-percent data-mattress-handle');
  $('.mattress-add-on.selection').show();
  $('#mattress-pop input[name="mattress_option"]').prop('checked', false);
  $('#mattress-pop .lmb-mattress-selection-status').text('Choose A Mattress To Add To Your Bed');
  $('#mattress-pop .btn-mattress-cart').prop('disabled', true).text($('#mattress-pop').attr('data-confirm-label'));
}

// Applies both tab-filter and size-filter to side-modal mattress labels.
  // Called on popup open, size change, and tab click.
  function applyMattressFilters() {
    // Read selected bed size
    var $sizeRadio = $('input[name="option-1"]:checked');
    var selectedSize = $sizeRadio.length
      ? String($sizeRadio.data('option-value') || $sizeRadio.val())
      : null;
    if (!selectedSize) {
      var $altRadio = $('#size_options input[type="radio"]:checked');
      if ($altRadio.length) selectedSize = $altRadio.val();
    }

    var $filters = $('#mattress-pop [data-mattress-filter]');
    var requiresRailMattressConfirmation = $('#mattress-pop').attr('data-side-rail-limit') === '16'
      && /^add safety side rails$/i.test(String($('.product-option--safety-side-rails input:checked').attr('data-name') || '').trim());
    var activeHandle = $filters.filter('[aria-pressed="true"]').attr('data-mattress-filter');
    var availableHandles = new Set();
    var money = function (price) {
      return (typeof Shopify !== 'undefined' && Shopify.formatMoney)
        ? Shopify.formatMoney(price)
        : '\u00a3' + (price / 100).toFixed(2);
    };

    $('.mattress-list-ss label').each(function () {
      var $label = $(this);
      var collectionHandle = $label.data('collection-handle') || '';
      var $input = $label.find('input[type="radio"]');
      var variants = $input.data('mattress-variants') || [];

      // Size filter: find variant whose title contains the selected size
      var sizeMatch = true;
      var matchedVariant = null;

      if (selectedSize && variants.length) {
        for (var i = 0; i < variants.length; i++) {
          var vTitle = String(variants[i].title || '');
          if (vTitle.toLowerCase().indexOf(selectedSize.toLowerCase()) !== -1) {
            matchedVariant = variants[i];
            break;
          }
        }
        sizeMatch = !!matchedVariant && matchedVariant.available !== false;
      }

      if (requiresRailMattressConfirmation) sizeMatch = false;

      if (sizeMatch) {
        availableHandles.add(collectionHandle);
        if (matchedVariant) {
          $input.val(matchedVariant.id).attr('data-price', matchedVariant.price);
          var percent = Number($input.attr('data-promo-percent')) || 0;
          var price = promotionalPrice(matchedVariant.price, percent);
          $label.find('.mattress-price').html(money(price)).attr('data-base-price', price);
          $label.find('.lmb-mattress-was').prop('hidden', price >= matchedVariant.price).find('span').html(money(matchedVariant.price));
          $label.find('.lmb-mattress-saving').prop('hidden', price >= matchedVariant.price).find('span').html(money(matchedVariant.price - price));
          var $details = $label.find('.lmb-mattress-details');
          var detailsUrl = new URL($details.attr('data-product-url'), window.location.origin);
          detailsUrl.searchParams.set('variant', matchedVariant.id);
          $details.attr('href', detailsUrl.pathname + detailsUrl.search);
        }
      }
      $label.attr('data-size-match', String(sizeMatch));
      $input.prop('disabled', !sizeMatch);

      if ($('.mattress-add-on.selected').attr('data-mattress-handle') === $label.attr('data-mattress-handle')) {
        if (sizeMatch) confirmMattressChoice($input);
        else clearMattressChoice();
      }

    });
    if (!activeHandle || !availableHandles.has(activeHandle)) {
      var $firstAvailable = $filters.filter(function () {
        return availableHandles.has($(this).attr('data-mattress-filter'));
      }).first();
      activeHandle = ($firstAvailable.length ? $firstAvailable : $filters.first()).attr('data-mattress-filter');
    }
    $filters.each(function () {
      var handle = $(this).attr('data-mattress-filter');
      $(this).attr('aria-pressed', String(handle === activeHandle)).prop('disabled', !availableHandles.has(handle));
    });
    var visibleCount = 0;
    $('#mattress-pop .mattress-list-ss label').each(function () {
      var $label = $(this);
      var visible = $label.attr('data-size-match') === 'true' && $label.attr('data-collection-handle') === activeHandle;
      $label.prop('hidden', !visible).toggle(visible);
      if (visible) visibleCount++;
    });
    $('#mattress-pop .lmb-mattress-depth-help').prop('hidden', !requiresRailMattressConfirmation);
    $('#mattress-pop .lmb-mattress-empty').prop('hidden', visibleCount > 0 || requiresRailMattressConfirmation);
  }

  // Called when the mattress popup opens.
  function updateMattressPricesForSize() {
    applyMattressFilters();
  }

  let mattressReturnFocus = null;
  let mattressPreviousOverflow = '';

  function closeMattressDialog() {
    document.querySelectorAll('.side-model-mattress.open').forEach(popup => {
      popup.classList.remove('open');
      popup.removeAttribute('aria-modal');
    });
    document.body.classList.remove('mattress-overlay-open');
    document.body.style.overflow = mattressPreviousOverflow;
    const visibleReturnTrigger = mattressReturnFocus && mattressReturnFocus.isConnected
      && mattressReturnFocus.getClientRects().length > 0;
    const selectedSummary = Array.from(document.querySelectorAll('.mattress-add-on.selected'))
      .find(summary => summary.getClientRects().length > 0);
    const focusTarget = visibleReturnTrigger ? mattressReturnFocus : selectedSummary;
    if (focusTarget) {
      if (focusTarget === selectedSummary) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.close-side-model')) closeMattressDialog();
    if (e.target === document.body && document.body.classList.contains('mattress-overlay-open')) {
      closeMattressDialog();
    }
  });

  document.addEventListener('keydown', function (e) {
    const popup = document.querySelector('.side-model-mattress.open');
    if (!popup) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeMattressDialog();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = Array.from(popup.querySelectorAll('button, input, select, a[href], [tabindex="0"]'))
      .filter(el => !el.disabled && el.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) {
      e.preventDefault();
      popup.focus();
    } else if (e.shiftKey && (document.activeElement === first || !popup.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !popup.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  });

  document.querySelectorAll('[data-dilog]').forEach(btn => {
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-controls', btn.getAttribute('data-dilog'));
  });
  document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-dilog]');
      if (!trigger) return;
      const popupId = trigger.getAttribute('data-dilog');
      const popup = document.getElementById(popupId);
      if (!popup) return;
      event.preventDefault();
      mattressReturnFocus = trigger;
      mattressPreviousOverflow = document.body.style.overflow;
      document.body.appendChild(popup);
      popup.setAttribute('role', 'dialog');
      popup.setAttribute('aria-modal', 'true');
      popup.setAttribute('tabindex', '-1');
      const heading = popup.querySelector('h3');
      if (heading) {
        heading.id = popupId + '-heading';
        popup.setAttribute('aria-labelledby', heading.id);
      }
      popup.classList.add('open');
      document.body.classList.add('mattress-overlay-open');
      document.body.style.overflow = 'hidden';
      if (popupId === 'mattress-pop') updateMattressPricesForSize();
      const closeButton = popup.querySelector('.close-side-model');
      (closeButton || popup).focus({ preventScroll: true });
  });
$(document).ready(function () {
  'use strict';

  // Keep the premium delivery-service buttons in sync with the hidden selector
  // used by the existing bundled add-to-cart flow.
  $(document).on('click', '[data-service-id]', function () {
    var selectedId = String($(this).data('service-id'));

    $('[data-service-id]').attr('aria-pressed', 'false');
    $(this).attr('aria-pressed', 'true');
    $('select[name="assembly_options"]').val('');
    $(this)
      .closest('[data-delivery-services]')
      .find('select[name="assembly_options"]')
      .val(selectedId)
      .trigger('change');
  });

  $(document).on('click', '[data-service-clear]', function () {
    $('[data-service-id]').attr('aria-pressed', 'false');
    $('select[name="assembly_options"]').val('').trigger('change');
  });

  $(document).on('change', '#mattress-pop input[name="mattress_option"]', function () {
    confirmMattressChoice($(this));
    updateVariantPrices();
  });

  $(document).on('click', '.btn-mattress-cart', function () {
    const selectedInput = $('.mattress-list-ss input[type="radio"]:checked');
    if (selectedInput.length === 0) {
      alert('Please select a mattress');
      return;
    }

    // Each radio is already the exact variant the user chose — copy its label HTML
    // into the selected state panel and close the popup.
    confirmMattressChoice(selectedInput);
    closeMattressDialog();
    updateVariantPrices();
  });

  $(document).on('click', '.mattress-add-on.selected a.remove-selection', function (e) {
    e.preventDefault();
    clearMattressChoice();
    $('.mattress-list-ss input[type="radio"]').prop('checked', false);
    updateVariantPrices();
  });

  // Mattress type filter tabs — click to filter by collection + re-apply size filter
  $(document).on('click', '#mattress-pop [data-mattress-filter]', function () {
    $('#mattress-pop [data-mattress-filter]').attr('aria-pressed', 'false');
    $(this).attr('aria-pressed', 'true');
    applyMattressFilters();
  });
  $(document).on('click', '.lmb-mattress-details', function (e) { e.stopPropagation(); });
  var firmnessOrder = ['medium firm', 'firm', 'medium', 'very firm', 'soft'];
  var $firmnessList = $('#mattress-pop .mattresses-filter-tab');
  var sortedFirmnessItems = $firmnessList.children('li').get().sort(function (a, b) {
    var rank = function (el) {
      var index = firmnessOrder.indexOf($(el).text().trim().toLowerCase());
      return index < 0 ? firmnessOrder.length : index;
    };
    return rank(a) - rank(b);
  });
  $firmnessList.append(sortedFirmnessItems);


  // =====================================================
  // SECTION 1: UTILITY FUNCTIONS
  // =====================================================


  // on click .product-option-values.option-mattress-values .option-value .mattress-add, .product-option-values.option-assembly-values .option-value .assembly-add nearest input[type="radio"] → check the radio and trigger change (to allow clicking the "+£XX.XX" span)

  $(document).on('click', '.product-option-values.option-mattress-values .option-value .mattress-add, .product-option-values.option-assembly-values .option-value .assembly-add', function (e) {
    e.preventDefault();
    var $optionValue = $(this).closest('.option-value');
    var $radio = $optionValue.find('input[type="radio"]');
    if ($radio.length) {
      $radio.prop('checked', true).trigger('change');
    }
  });

  function formatPrice(priceInCents) {
    return '\u00A3' + (priceInCents / 100).toFixed(2);
  }

  function formatPriceDifference(difference) {
    if (difference === 0) return formatPrice(0);
    var prefix = difference > 0 ? '+' : '-';
    var absoluteValue = Math.abs(difference);
    return prefix + '\u00A3' + (absoluteValue / 100).toFixed(2);
  }

  function getProductVariantsData() {
    var dataScript = document.getElementById('product-variants-data');
    if (dataScript) {
      try {
        var data = JSON.parse(dataScript.textContent);
        if (document.querySelector('.product-option-main--divan')) {
          data.variants = data.variants.filter(function (variant) {
            return ![variant.option1, variant.option2, variant.option3].some(function (value) {
              return /^70\s*["\u2033]?\s*(?:headboard)?$/i.test(String(value || '').trim());
            });
          });
        }
        return data;
      } catch (e) {
        console.error('Failed to parse product variants data:', e);
      }
    }
    return { variants: [] };
  }

  function normalizeOptionValue(value) {
    if (!value) return value;
    return value.replace(/["']+$/g, '').trim();
  }

  // =====================================================
  // SECTION 2: VARIANT MATCHING
  // =====================================================

  function findMatchingVariant(selectedOptions) {
    var variantsData = getProductVariantsData();
    var searchOptionCount = 0;
    for (var key in selectedOptions) {
      if (key.indexOf('option') === 0) searchOptionCount++;
    }

    var unavailableMatch = null;
    for (var i = 0; i < variantsData.variants.length; i++) {
      var variant = variantsData.variants[i];
      var matchCount = 0;
      var failed = false;

      for (var j = 1; j <= 3; j++) {
        var optionKey = 'option' + j;
        if (selectedOptions[optionKey]) {
          var normalizedSelected = normalizeOptionValue(selectedOptions[optionKey]);
          var normalizedVariant = normalizeOptionValue(variant[optionKey]);
          if (normalizedVariant === normalizedSelected) {
            matchCount++;
          } else {
            failed = true;
            break;
          }
        }
      }

      if (!failed && matchCount === searchOptionCount && matchCount > 0) {
        if (variant.available !== false) return variant;
        if (!unavailableMatch) unavailableMatch = variant;
      }
    }
    return unavailableMatch;
  }

  function getSelectedProductOptions() {
    var selectedOptions = {};
    $('.product-option input[type="radio"][data-option-position]:checked').each(function () {
      var optionPosition = parseInt($(this).data('option-position'));
      var optionValue = $(this).data('option-value') || $(this).val();
      if (optionPosition && optionValue) {
        selectedOptions['option' + optionPosition] = String(optionValue);
      }
    });
    return selectedOptions;
  }

  // =====================================================
  // SECTION 3: PRICE CALCULATION ENGINE
  // =====================================================

  var lastDisplayedVariantId = null;

  function updateVariantMedia(variant) {
    if (!variant || variant.id === lastDisplayedVariantId) return;
    lastDisplayedVariantId = variant.id;
    if (!variant.featured_media_id) return;
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var media = gallery.querySelector('[data-media-id$="-' + variant.featured_media_id + '"]');
      if (media && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(media.getAttribute('data-media-id'), false);
      }
    });
  }

  function updateVariantPrices() {
    var totalPrice = 0;
    var totalCompareAtPrice = 0;
    var hasCompareAt = false;
    var promoPercent = parseFloat($('h3.product-price').attr('data-promo-percent')) || 0;
    var parentFixedSaving = parseInt($('h3.product-price').attr('data-promo-fixed'), 10) || 0;
    var hasMixedPromotions = false;

    // 1. Get base variant price
    var selectedOptions = getSelectedProductOptions();
    var matchingVariant = findMatchingVariant(selectedOptions);
    var $configuration = $('.lmb-price-configuration');
    var optionNames = [];
    try { optionNames = JSON.parse($('.product-option-main').attr('data-option-names') || $configuration.attr('data-option-names') || '[]'); } catch (error) { /* Optional price summary. */ }
    var completeSelection = optionNames.every(function (_, index) {
      return !!selectedOptions['option' + (index + 1)];
    });
    var priceCandidates = getProductVariantsData().variants.filter(function (variant) {
      return variant.available !== false && Object.keys(selectedOptions).every(function (key) {
        return normalizeOptionValue(variant[key]) === normalizeOptionValue(selectedOptions[key]);
      });
    });
    if (!completeSelection && priceCandidates.length) {
      matchingVariant = priceCandidates.reduce(function (lowest, variant) {
        return variant.price < lowest.price ? variant : lowest;
      });
    }
    var showStartingPrice = !completeSelection && priceCandidates.some(function (variant) {
      return matchingVariant && variant.price !== matchingVariant.price;
    });
    updateVariantMedia(matchingVariant);
    // Existing sample links lead straight to the selector, with a safe route back.
    document.querySelectorAll('a[href*="/products/fabric-sample"]').forEach(function (link) {
      var sampleUrl = new URL(link.href);
      if (sampleUrl.origin !== window.location.origin || !/\/products\/fabric-sample\/?$/.test(sampleUrl.pathname)) return;
      var sourceUrl = new URL(window.location.pathname, window.location.origin);
      if (!/\/products\/[^/]+\/?$/.test(sourceUrl.pathname)) return;
      if (completeSelection && matchingVariant) sourceUrl.searchParams.set('variant', matchingVariant.id);
      sampleUrl.searchParams.set('return_to', sourceUrl.pathname + sourceUrl.search);
      sampleUrl.hash = 'FabricSampleSelector';
      link.href = sampleUrl.pathname + sampleUrl.search + sampleUrl.hash;
    });

    if (matchingVariant) {
      if (promoPercent > 0) {
        totalPrice = promotionalPrice(matchingVariant.price, promoPercent, parentFixedSaving);
        totalCompareAtPrice = matchingVariant.price;
        hasCompareAt = true;
      } else {
        totalPrice = matchingVariant.price;
      }
      if (promoPercent <= 0 && matchingVariant.compare_at_price && matchingVariant.compare_at_price > 0) {
        totalCompareAtPrice = matchingVariant.compare_at_price;
        hasCompareAt = true;
      }
    } else {
      // Fallback for single-variant products
      var variantsData = getProductVariantsData();
      if (variantsData.variants.length === 1) {
        if (promoPercent > 0) {
          totalPrice = promotionalPrice(variantsData.variants[0].price, promoPercent, parentFixedSaving);
          totalCompareAtPrice = variantsData.variants[0].price;
          hasCompareAt = true;
        } else {
          totalPrice = variantsData.variants[0].price;
        }
        if (promoPercent <= 0 && variantsData.variants[0].compare_at_price && variantsData.variants[0].compare_at_price > 0) {
          totalCompareAtPrice = variantsData.variants[0].compare_at_price;
          hasCompareAt = true;
        }
      }
    }

    if (!matchingVariant && totalPrice <= 0) {
      var baseRawPrice = parseInt($('h3.product-price').attr('data-base-price'), 10) || 0;
      var baseComparePrice = parseInt($('h3.product-price').attr('data-base-compare-at'), 10) || 0;
      totalPrice = promotionalPrice(baseRawPrice, promoPercent, parentFixedSaving);
      totalCompareAtPrice = promoPercent > 0 ? baseRawPrice : baseComparePrice;
      hasCompareAt = totalCompareAtPrice > totalPrice;
    }

    if (!hasCompareAt) totalCompareAtPrice = totalPrice;

    function includeAddon($option) {
      var rawPrice = parseInt($option.attr('data-price'), 10) || 0;
      var percent = Number($option.attr('data-promo-percent')) || 0;
      if (rawPrice > 0 && percent !== promoPercent) hasMixedPromotions = true;
      var payable = promotionalPrice(rawPrice, percent);
      totalPrice += payable;
      totalCompareAtPrice += rawPrice;
      if (payable < rawPrice) hasCompareAt = true;
    }

    // 2. Add metafield addon prices
    $('.product-option input[type="radio"]:checked[data-price]').each(function () {
      // Skip product variant options (they have data-option-position)
      if ($(this).data('option-position')) return;
      // Skip mattress and assembly
      var name = $(this).attr('name');
      if (name === 'option-mattress' || name === 'option-assembly') return;

      includeAddon($(this));
    });

    // 3. Add mattress price
    var $confirmedMattress = $('.mattress-add-on.selected[data-variant-id]').first();
    var $selectedMattress = $('input[name="option-mattress"]:checked');
    if ($confirmedMattress.length) includeAddon($confirmedMattress);
    else if ($selectedMattress.length && $selectedMattress.val()) includeAddon($selectedMattress);

    // 4. Add assembly price
    var $selectedService = $('select[name="assembly_options"] option:selected').filter(function () { return !!this.value; }).last();
    var $selectedAssembly = $('input[name="option-assembly"]:checked');
    if ($selectedService.length) includeAddon($selectedService);
    else if ($selectedAssembly.length && $selectedAssembly.val()) includeAddon($selectedAssembly);

    // Before a guided option is chosen, keep the advertised starting price
    // instead of briefly replacing the product and finance totals with £0.
    if (totalPrice <= 0) {
      var fallbackRawPrice = parseInt($('h3.product-price').attr('data-base-price'), 10) || 0;
      var fallbackCompareAt = parseInt($('h3.product-price').attr('data-base-compare-at'), 10) || 0;
      totalPrice = promotionalPrice(fallbackRawPrice, promoPercent, parentFixedSaving);
      if (promoPercent > 0) {
        totalCompareAtPrice = fallbackRawPrice;
        hasCompareAt = true;
      } else if (fallbackCompareAt > fallbackRawPrice) {
        totalCompareAtPrice = fallbackCompareAt;
        hasCompareAt = true;
      }
    }

    // 5. Update price display
    var $priceContainer = $('h3.product-price');
    var $priceBox = $('.product-option-main .product-price-box');
    var $promotionLabel = $priceBox.find('.lmb-price-promotion-label');
    if (!$promotionLabel.attr('data-original-label')) $promotionLabel.attr('data-original-label', $promotionLabel.text());
    $promotionLabel.text($promotionLabel.attr('data-original-label'));
    $priceBox.find('.lmb-price-promotion-note').prop('hidden', !hasMixedPromotions);
    var formattedCurrent = formatPrice(totalPrice);
    var displayedCurrent = (showStartingPrice ? ($priceContainer.attr('data-from-label') || 'From') + ' ' : '') + formattedCurrent;
    $priceContainer.find('.product-price--current').text(displayedCurrent);
    if ($configuration.length && matchingVariant) {
      var configurationText = optionNames.map(function (name, index) {
        var value = matchingVariant['option' + (index + 1)];
        return name.toLowerCase() === 'configuration' ? value : name + ': ' + value;
      }).join(' · ');
      $configuration.find('.lmb-price-configuration__label').text($configuration.attr(completeSelection ? 'data-selected-label' : 'data-starting-label') + ':');
      $configuration.find('.lmb-price-configuration__value').text(configurationText);
      $configuration.find('.lmb-price-configuration__prompt').toggle(!completeSelection);
    }

    // 5b. Mirror the live total inside the sticky add-to-basket button
    $('.lmb-sticky-atc__button-price').text(displayedCurrent);
    $('.lmb-sticky-atc__price-current').text(displayedCurrent);

    // 6. Update compare-at price and savings
    if (hasCompareAt && totalCompareAtPrice > totalPrice) {
      $priceContainer.find('.product-price--compare').text(formatPrice(totalCompareAtPrice)).show();
      $('.lmb-sticky-atc__price-compare').text(formatPrice(totalCompareAtPrice)).show();

      var savings = totalCompareAtPrice - totalPrice;
      $priceContainer.find('.product-price--discount').text('You Save ' + formatPrice(savings)).show();
    } else {
      $priceContainer.find('.product-price--compare').hide();
      $('.lmb-sticky-atc__price-compare').hide();
      $priceContainer.find('.product-price--discount').hide();
    }

    // 6b. Update finance monthly amount (12-month split)
    var $financeAmount = $priceBox.find('.product-price--finance-amount');
    if ($financeAmount.length) {
      $financeAmount.text(formatPrice(Math.round(totalPrice / 12)));
      $priceBox.find('.product-price--finance').attr('aria-label', 'From ' + formatPrice(Math.round(totalPrice / 12)) + ' Per Month At Zero Percent Interest');
    }

    // 7. Update per-option price differences
    updatePriceDifferences(selectedOptions, completeSelection ? matchingVariant : null);

    // 8. Update accordion header labels
    updateAccordionLabels();
    updateDivanTabLabels();
    updateBedStepLabels();
    var lmbAllVariants = getProductVariantsData().variants;
    var lmbParentVariant = matchingVariant || (lmbAllVariants.length === 1 ? lmbAllVariants[0] : null);
    var lmbQuote = {
      variantId: lmbParentVariant ? lmbParentVariant.id : null,
      totalPence: lmbParentVariant ? totalPrice : null,
      comparePence: lmbParentVariant ? (hasCompareAt ? totalCompareAtPrice : totalPrice) : null,
      available: !!lmbParentVariant && lmbParentVariant.available !== false,
      inventoryManaged: !!lmbParentVariant && !!lmbParentVariant.inventory_management,
      inventoryQuantity: lmbParentVariant ? lmbParentVariant.inventory_quantity : 0,
      complete: completeSelection || lmbAllVariants.length === 1,
      from: showStartingPrice,
      selectionText: lmbParentVariant ? optionNames.map(function (_, index) { return lmbParentVariant['option' + (index + 1)]; }).filter(function (value) { return value && value !== 'Default Title'; }).join(' · ') : ''
    };
    window.lmbLatestPurchaseQuote = lmbQuote;
    document.dispatchEvent(new CustomEvent('lmb:purchase-quote', {detail:lmbQuote}));
  }

  // =====================================================
  // SECTION 4: PRICE DIFFERENCES
  // =====================================================

  function updatePriceDifferences(selectedOptions, currentVariant) {
    var optionPromo = parseFloat($('h3.product-price').attr('data-promo-percent')) || 0;
    var optionFixedSaving = parseInt($('h3.product-price').attr('data-promo-fixed'), 10) || 0;
    var optionMultiplier = (100 - optionPromo) / 100;
    var currentPrice = currentVariant ? promotionalPrice(currentVariant.price, optionPromo, optionFixedSaving) : 0;
    var showTotalOptionPrices = /\/products\/conway-leather-electric-sofa-bed\/?$/.test(window.location.pathname);

    // Product option radios (have data-option-position) — show +/- difference
    $('.product-option').each(function () {
      var $section = $(this);
      var $radios = $section.find('input[type="radio"][data-option-position]');
      if ($radios.length === 0) return;

      $radios.each(function () {
        var $radio = $(this);
        var optionValue = String($radio.data('option-value') || $radio.val());
        var optionPosition = parseInt($radio.data('option-position'));
        var $label = $radio.closest('.option-value');
        var $priceSpan = $label.find('.variant-price');

        // Build hypothetical options with this value swapped in
        var hypothetical = $.extend({}, selectedOptions);
        if (optionValue && optionPosition) {
          hypothetical['option' + optionPosition] = optionValue;
        }

        // A different size may require a different drawer layout. Keep the size
        // selectable; the change handler switches unsupported layouts to No Storage.
        if ($section.closest('.product-option-main--divan').length && optionPosition === 1) {
          var $nativeStorage = $('.product-option-main--divan .product-option--storage input[data-option-position]').first();
          var storagePos = Number($nativeStorage.attr('data-option-position'));
          if (storagePos && /^(Small Single|Single) \(/.test(optionValue)) {
            var storageValue = hypothetical['option' + storagePos] || '';
            if (/foot|^4/i.test(storageValue)) hypothetical['option' + storagePos] = 'No Storage';
          }
        }
        var hypotheticalVariant = findMatchingVariant(hypothetical);
        var hypotheticalPrice = hypotheticalVariant ? promotionalPrice(hypotheticalVariant.price, optionPromo, optionFixedSaving) : 0;

        if (!hypotheticalVariant || hypotheticalVariant.available === false) {
          $radio.prop('disabled', true);
          $label.addClass('unavailable');
          $priceSpan.text('');
        } else {
          $radio.prop('disabled', false);
          $label.removeClass('unavailable');
          var priceDifference = hypotheticalPrice - currentPrice;
          var showDiscountedBedSizePrice = optionPromo === 40 && $section.hasClass('product-option--size');
          $priceSpan.text(currentVariant && !showTotalOptionPrices && !showDiscountedBedSizePrice ? formatPriceDifference(priceDifference) : formatPrice(hypotheticalPrice));
        }
      });
    });

    // Metafield option radios (have data-price, no data-option-position) — show as +£XX.XX
    $('.product-option input[type="radio"][data-price]').each(function () {
      if ($(this).data('option-position')) return;
      var name = $(this).attr('name');
      if (name === 'option-mattress' || name === 'option-assembly') return;

      var variantPrice = parseInt($(this).data('price')) || 0;
      var variantPromo = Number($(this).attr('data-promo-percent')) || 0;
      variantPrice = promotionalPrice(variantPrice, variantPromo);
      var $label = $(this).closest('.option-value');
      var $priceSpan = $label.find('.variant-price');

      if ($priceSpan.length) {
        if (variantPrice > 0) {
          $priceSpan.text('+' + formatPrice(variantPrice));
        } else {
          $priceSpan.text(formatPrice(variantPrice));
        }
      }
    });
  }

  // =====================================================
  // SECTION 5: ACCORDION LABELS
  // =====================================================

  function updateAccordionLabels() {
    $('.product-option').each(function () {
      var $section = $(this);
      var $selected = $section.find('.option-value input[type="radio"]:checked');
      if ($selected.length) {
        var selectedName = $selected.data('name') || $selected.val();
        $section.find('h3 span b').text('Selected: ' + selectedName);
        $section.addClass('is-complete');
      } else {
        $section.find('h3 span b').text('');
        $section.removeClass('is-complete');
      }
    });
  }

  // =====================================================
  // SECTION 6: SIZE-BASED FILTERING
  // =====================================================

  function getSelectedSize() {
    var $sizeRadio = $('input[name="option-1"]:checked');
    if ($sizeRadio.length) {
      return String($sizeRadio.data('option-value') || $sizeRadio.val());
    }
    var $altRadio = $('#size_options input[type="radio"]:checked');
    if ($altRadio.length) {
      return $altRadio.val();
    }
    return null;
  }

  function filterMattressBySize() {
    var selectedSize = getSelectedSize();
    if (!selectedSize) return;

    const countselectedSize = document.querySelectorAll(
      `.product-option-values .option-value[data-mattress-size="${selectedSize}"]`
    ).length;

    if(countselectedSize == 0){
      $('p.no-mattress-message').show();
    }else{
      $('p.no-mattress-message').hide();
    }

    $('.option-mattress-values .option-value').each(function () {
      var mattressSize = $(this).data('mattress-size');
      // Always show "No Mattress" or items without a size
      if (!mattressSize || mattressSize === 'No Mattress' || mattressSize === selectedSize) {

        $(this).show();
      } else {
        $(this).hide();
        var $radio = $(this).find('input[type="radio"]');
        if ($radio.prop('checked')) {
          $radio.prop('checked', false);
        }
      }
    });

    // Also filter side-modal labels by size + active tab
    applyMattressFilters();
  }

  function filterStorageOptions() {
    var selectedSize = getSelectedSize();
    if (!selectedSize) return;
    var isSmallSize = /^(Small Single|Single) \(/.test(selectedSize);
    $('.product-option').each(function () {
      var $section = $(this);
      var isDivan = $section.closest('.product-option-main--divan').length > 0;
      var sectionTitle = $section.find('h3 span').first().text().toLowerCase();
      if (sectionTitle.indexOf('storage') === -1 && sectionTitle.indexOf('drawer') === -1) return;
      var reset = false;
      $section.find('.option-value').each(function () {
        var $label = $(this), $radio = $label.find('input[type=radio]');
        var text = String($radio.attr('data-name') || $label.find('span').first().text()).trim();
        var restricted = isDivan ? /foot|^4\s*drawers/i.test(text) : ['Footend 2 Drawers','4 Drawers'].indexOf(text) !== -1;
        var unavailable = isSmallSize && restricted;
        if (isDivan) $label.prop('hidden',unavailable);
        else $label.toggle(!unavailable);
        if (unavailable && $radio.prop('checked')) { $radio.prop('checked',false); reset=true; }
      });
      if(reset) {
        var $none=$section.find('input[type=radio]').filter(function(){return String($(this).attr('data-name') || $(this).val())==='No Storage';}).first();
        $none.prop('checked',true);
      }
    });
  }

  function filterTvOptions() {
    var selectedSize = getSelectedSize();
    if (!selectedSize) return;
    var allowedTitle = {
      'Double (4FT6)': 'Double Size TV Footend',
      'Kingsize (5FT)': 'King Size TV Footend',
      'Superking (6FT)': 'Superking Size TV Footend'
    }[selectedSize];
    var $section = $('.product-option--upgrade-to-a-tv-bed');
    $section.find('.option-value').each(function () {
      var $input = $(this).find('input[type="radio"]');
      var title = $input.attr('data-name');
      var visible = title === 'No' || title === allowedTitle;
      $(this).toggle(visible);
      if (!visible && $input.prop('checked')) {
        $input.prop('checked', false);
        $section.find('input[data-name="No"]:not(:disabled)').prop('checked', true);
      }
    });
  }

  // =====================================================
  // SECTION 7: VALIDATION
  // =====================================================

  // Resolve a clean section title for a .product-option.
  // Prefer the data-section-title emitted in Liquid; fall back to the heading
  // text with the injected selected-value <b> and the sub-heading <p> removed
  // (scraping h3 span text directly pulls those in and pollutes the property name).
  function getSectionTitle($section) {
    var attrTitle = $section.attr('data-section-title');
    if (!attrTitle) attrTitle = $section.find('h3[data-section-title]').attr('data-section-title');
    if (attrTitle) return attrTitle.trim();

    var $heading = $section.find('h3 .title-icon-accordion').first();
    if (!$heading.length) $heading = $section.find('h3 span').first();
    var $clone = $heading.clone();
    $clone.find('b, p, img, br').remove();
    return $clone.text().replace(/Choose\s+/i, '').replace(/\s*-\s*$/, '').trim();
  }

  function validateMetafieldSelections() {
    var errors = [];

    $('.product-option').each(function () {
      var $section = $(this);
      var $radios = $section.find('.option-value input[type="radio"]');
      if ($radios.length === 0) return;
      var $ringGroups = $section.find('[data-luma-ring-group]');
      if ($ringGroups.length) {
        $ringGroups.each(function () {
          var $group = $(this);
          if (!$group.find('input[type=radio]:checked:not(:disabled)').length) {
            errors.push({ sectionTitle: $group.attr('data-ring-title'), $section: $section, $group: $group });
          }
        });
        return;
      }

      // Skip mattress and assembly (they are optional)
      var radioName = $radios.first().attr('name');
      if (radioName === 'option-mattress' || radioName === 'option-assembly') return;
      if ($radios.filter('[data-name="No Thanks"]').length) return;

      var $selected = $section.find('.option-value input[type="radio"]:checked');
      if ($selected.length === 0) {
        var sectionTitle = getSectionTitle($section);
        errors.push({
          sectionTitle: sectionTitle,
          $section: $section
        });
      }
    });

    return errors;
  }

  function showError(message) {
    $('.product-option-error').remove();
    var $error = $('<div class="product-option-error"></div>').text(message);
    $error.insertBefore('.add-to-cart-btn');
  }

  function clearErrors() {
    $('.product-option-error').remove();
    $('.product-option.error').removeClass('error');
  }

  // =====================================================
  // SECTION 8: ADD TO CART
  // =====================================================

  function generateBundleId() {
    return 'bundle_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  function getMainProductTitle() {
    var $title = $('.product__title h1');
    if (!$title.length) $title = $('h1.product__title');
    if (!$title.length) $title = $('[data-product-title]');
    return $title.length ? $title.first().text().trim() : 'Main Product';
  }

  function getOrderOptionLabel(title) {
    var label = String(title || '').replace(/^choose\s+/i, '').trim();
    var key = label.toLowerCase();
    var labels = {
      'your fabric and colour': 'Fabric / colour',
      'fabric and colour': 'Fabric / colour',
      'maximise your storage space': 'Base / storage',
      'upgrade to a tv bed': 'TV footend',
      'change your bedroom look': 'Matching storage',
      'headboard height': 'Headboard height'
    };
    return labels[key] || label;
  }

  function isEmptyOrderChoice(title, rawPrice) {
    return String(rawPrice || '').trim() !== '' && Number(rawPrice) === 0
      && /^(no|no thanks|none|no upgrade|no storage|without safety side rails)$/i.test(String(title || '').trim());
  }

  function selectedMattressTitle($input, mattressId) {
    var title = String($input.closest('label').find('h4').first().text()
      || $input.attr('data-title') || $input.attr('data-name') || '').trim();
    try {
      var variants = JSON.parse($input.attr('data-mattress-variants') || '[]');
      var selected = variants.find(function (variant) {
        return Number(variant.id) === mattressId;
      });
      if (selected && selected.title && selected.title !== 'Default Title') {
        title += (title ? ' - ' : '') + selected.title;
      }
    } catch (error) {}
    return title;
  }

  function handleAddToCart(e) {
    e.preventDefault();
    clearErrors();
    applyMattressFilters();

    var $btn = $(e.currentTarget);

    // Validate metafield selections
    var validationErrors = validateMetafieldSelections();
    if (validationErrors.length > 0) {
      validationErrors.forEach(function (error) {
        error.$section.addClass('error');
        if (error.$group) error.$group.prop('open', true);
      });
      var missingOptions = validationErrors.map(function (e) { return e.sectionTitle; }).join(', ');
      showError('Please select an option for: ' + missingOptions);

      // Open first erroring accordion and scroll to it
      var $firstError = validationErrors[0].$section;
      if ($firstError.attr('data-divan-panel')) openDivanTab($firstError.attr('data-divan-panel'));
      if ($firstError.attr('data-bed-panel')) openBedStep($firstError.closest('.lmb-bed-config'), $firstError.attr('data-bed-panel'), true);
      $('.product-option-values').removeClass('active');
      $('.product-option h3').attr('aria-expanded', 'false');
      $('.product-option .icon-accordion').removeClass('rotated');
      $firstError.find('.product-option-values').addClass('active');
      $firstError.find('h3').attr('aria-expanded', 'true');
      $firstError.find('.icon-accordion').addClass('rotated');
      if ($firstError.attr('data-bed-panel')) openBedStep($firstError.closest('.lmb-bed-config'), $firstError.attr('data-bed-panel'));
      $('html, body').animate({
        scrollTop: $firstError.offset().top - 100
      }, 400);
      return;
    }

    // Get main variant
    var selectedOptions = getSelectedProductOptions();
    var mainVariant = findMatchingVariant(selectedOptions);

    if (!mainVariant) {
      var variantsData = getProductVariantsData();
      mainVariant = variantsData.variants.length === 1 ? variantsData.variants[0] : null;
    }

    if (!mainVariant) {
      showError('Please select a valid product variant.');
      return;
    }
    if (mainVariant.available === false) {
      showError('This combination is currently unavailable. Please choose another option.');
      return;
    }

    var ottomanPicker = document.querySelector('lmb-madelyn-ottoman');
    if (ottomanPicker && !ottomanPicker.validate()) return;
    var ottomanSelection = ottomanPicker ? ottomanPicker.selection() : null;

    // Collect metafield variant selections
    var metafieldVariants = [];
    var bundleId = generateBundleId();
    var mainProductTitle = getMainProductTitle();
    var mainProductProperties = { '_bundle_id': bundleId };

    $('.product-option input[type="radio"]:checked[data-variant-id]').each(function () {
      if ($(this).data('option-position')) return;
      var name = $(this).attr('name');
      if (name === 'option-mattress' || name === 'option-assembly') return;

      var variantId = parseInt($(this).data('variant-id'));
      var variantTitle = $(this).data('name') || '';
      var sectionTitle = $(this).attr('data-order-property') || getOrderOptionLabel(getSectionTitle($(this).closest('.product-option')));
      var rawPrice = $(this).attr('data-price');
      mainProductProperties[sectionTitle] = variantTitle;
      if ($(this).attr('data-property-only') === 'true') return;
      if (isEmptyOrderChoice(variantTitle, rawPrice)) return;

      metafieldVariants.push({
        id: variantId,
        title: variantTitle,
        sectionTitle: sectionTitle
      });
    });

    // Get selected quantity
    var qty = parseInt($('#quantity').val()) || 1;

    // Build cart items
    var cartItems = [];

    // Main product
    cartItems.push({
      id: mainVariant.id,
      quantity: qty,
      properties: mainProductProperties
    });

    if (ottomanSelection) {
      cartItems.push({
        id: ottomanSelection.id,
        quantity: ottomanSelection.quantity,
        properties: { 'For sofa': mainProductTitle }
      });
    }

    // Metafield child products
    metafieldVariants.forEach(function (variant) {
      cartItems.push({
        id: variant.id,
        quantity: qty,
        parent_id: mainVariant.id,
        properties: {
          '_bundle_id': bundleId,
          '_parent_product': mainProductTitle
        }
      });
    });

    // Read the actual choice; selecting a card commits it immediately.
    var mattressId = 0;
    var $chosenMattress = $('#mattress-pop input[name="mattress_option"]:checked:not(:disabled)').first();
    mattressId = parseInt($chosenMattress.val(), 10) || 0;
    if (!mattressId) {
      var $accordionMattress = $('input[name="option-mattress"]:checked');
      if ($accordionMattress.length && $accordionMattress.val()) {
        mattressId = parseInt($accordionMattress.val());
      }
    }
    if (!isNaN(mattressId) && mattressId > 0) {
      var $mattressInput = $chosenMattress.length ? $chosenMattress : $('input[name="option-mattress"]:checked').first();
      var mattressTitle = selectedMattressTitle($mattressInput, mattressId);
      if (mattressTitle) mainProductProperties['Mattress'] = mattressTitle;
      cartItems.push({
        id: mattressId,
        quantity: qty,
        parent_id: mainVariant.id,
        properties: {
          '_bundle_id': bundleId,
          '_parent_product': mainProductTitle
        }
      });
    }

        // Assembly — dropdown first, fall back to accordion.
    // There can be more than one select[name="assembly_options"] on the page
    // (e.g. the .info-desktop block and the buy-box block), so check them all
    // and take the one that has a value selected — .val() alone only reads the first.
    var assemblyId = 0;
    $('select[name="assembly_options"]').each(function () {
      var v = parseInt($(this).val());
      if (!isNaN(v) && v > 0) assemblyId = v;
    });
    if (!assemblyId) {
      var $accordionAssembly = $('input[name="option-assembly"]:checked');
      if ($accordionAssembly.length && $accordionAssembly.val()) {
        assemblyId = parseInt($accordionAssembly.val());
      }
    }
    if (!isNaN(assemblyId) && assemblyId > 0) {
      var serviceTitle = '';
      $('select[name="assembly_options"] option:selected').each(function () {
        if (Number($(this).val()) === assemblyId) {
          serviceTitle = String($(this).text()).trim().replace(/\s*[-–—]\s*[£$€].*$/, '').trim();
        }
      });
      if (!serviceTitle) {
        var $service = $('input[name="option-assembly"]:checked').first();
        serviceTitle = String($service.attr('data-title') || $service.attr('data-name') || '').trim();
      }
      if (serviceTitle) mainProductProperties['Delivery / assembly'] = serviceTitle;
      cartItems.push({
        id: assemblyId,
        quantity: qty,
        parent_id: mainVariant.id,
        properties: {
          '_bundle_id': bundleId,
          '_parent_product': mainProductTitle
        }
      });
    }

    // Disable button and show loading
    $btn.addClass('loading').text('Adding...').css('pointer-events', 'none');

    // Submit to Shopify AJAX API
    $.ajax({
      url: ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ items: cartItems }),
      dataType: 'json',
      success: function () {
        window.location.href = '/cart';
      },
      error: function (xhr) {
        var errorMsg = 'Failed to add to cart. Please try again.';
        try {
          var data = JSON.parse(xhr.responseText);
          if (data.description) errorMsg = data.description;
        } catch (err) {}
        showError(errorMsg);
        $btn.removeClass('loading').text($btn.attr('data-available-label') || 'Add to basket').css('pointer-events', 'auto');
      }
    });
  }

  // =====================================================
  // SECTION 9: FABRIC TYPE FILTERING
  // =====================================================

  function updateFabricSelection($section) {
    var $selected = $section.find('.lmb-fabric-swatch input:checked');
    var $status = $section.find('[data-fabric-selected]');
    $status.text($selected.length ? $selected.closest('label').attr('data-shade') : $status.attr('data-placeholder'));
    var $ring = $section.closest('[data-luma-ring-group]');
    if ($ring.length) {
      var $ringStatus = $ring.find('[data-luma-ring-selection]');
      $ringStatus.text($selected.length ? $selected.attr('data-name') : $ringStatus.attr('data-placeholder'));
      $ring.toggleClass('is-selected', !!$selected.length);
    }
  }

  function handleFabricTypeChange() {
    var selectedFabric = $(this).val();
    var $section = $(this).closest('[data-fabric-picker]');
    var $options = $section.find('.option-value[data-combo]');
    if (!selectedFabric || !$options.length) return;
    $options.each(function () {
      var matches = $(this).attr('data-combo') === selectedFabric;
      $(this).prop('hidden', !matches);
      if (!matches) $(this).find('input[type=radio]').prop('checked', false);
    });
    $section.find('[data-fabric-family]').each(function () {
      $(this).prop('hidden', !$(this).find('.option-value:not([hidden])').length);
    });
    updateFabricSelection($section);
    updateVariantPrices();
    clearErrors();
  }

  function setupFabricPickers() {
    var shadeOrder = 'white,ivory,cream,pearl,linen,natural,oatmeal,beige,almond,sand,latte,mink,truffle,caramel,mocca,mocha,chocolate,ice,silver,platinum,pebble,dove,grey,seal grey,slate grey,steel,armour,granite,charcoal,anthracite,coal,black,pink,rose,claret,oxblood,orange,saffron,mustard,turmeric,forest,emerald,teal,turquoise,sky,blue,marine,midnight,purple'.split(',');
    $('[data-fabric-picker]').each(function () {
      var $picker = $(this);
      $picker.find('.lmb-fabric-swatches').each(function () {
        var grid = this;
        $(grid).children('.option-value').get().sort(function (a, b) {
          var aRank = shadeOrder.indexOf(a.getAttribute('data-shade').toLowerCase());
          var bRank = shadeOrder.indexOf(b.getAttribute('data-shade').toLowerCase());
          return (aRank < 0 ? 999 : aRank) - (bRank < 0 ? 999 : bRank);
        }).forEach(function (option) { grid.appendChild(option); });
      });
      var $select = $picker.find('[data-fabric-select]');
      var $checked = $picker.find('input:checked');
      if ($checked.length) $select.val($checked.closest('label').attr('data-combo'));
      $select.on('change', handleFabricTypeChange);
      handleFabricTypeChange.call($select[0]);
      $picker.on('change', 'input[type=radio]', function () { updateFabricSelection($picker); });
    });
  }

  // =====================================================
  function setupDivanConfigurator() {
    var $root = $('.product-option-main--divan');
    if (!$root.length) return;
    var $list = $root.find('.product-options-list');
    var $size = $list.find('.product-option--size').first();
    var $storage = $list.find('.product-option--storage, .product-option--maximise-your-storage-space').first();
    var $headboard = $list.find('.product-option--headboard-height, .product-option--headboard').first();
    var $fabric = $list.find('.product-option--custom-fabric').first();
    var paths = {
      size: '<path d="M5 5v23h23Z M5 12h4M5 18h4M5 24h4M12 28v-4M18 28v-4M24 28v-4"/>',
      storage: '<path d="M9 4h14v24H9zM9 10h14M9 14H4v5h5M23 14h5v5h-5M9 22H4v5h5M23 22h5v5h-5"/>',
      headboard: '<path d="M5 28V9c0-8 22-8 22 0v19M5 23h22M10 9v9M16 7v11M22 9v9"/>',
      base: '<path d="M3 12h26v14H3zM3 12l5-6h16l5 6M6 26v3M26 26v3M16 12v14"/>'
    };
    var $config = $('<div class="lmb-divan-config"><div class="lmb-divan-tabs" role="tablist" aria-label="Build Your Divan"></div></div>');
    $config.prependTo($list);
    if ($fabric.length) $fabric.insertAfter($config);
    $list.children('hr').remove();
    var panels = [{key:'size',title:'Size',panel:$size},{key:'storage',title:'Storage',panel:$storage},{key:'headboard',title:'Headboard',panel:$headboard}];
    var $base = $('<div class="lmb-divan-base-panel"><img src="https://cdn.shopify.com/s/files/1/0576/6640/4418/files/lmb-divan-reinforced-base-23-sep.png?v=1790182815&width=640" width="1448" height="1086" alt="Illustration of reinforced divan base construction" loading="lazy"><h3>Reinforced Divan Base</h3><p><strong>Included In Your Bed Price</strong></p><p>A supportive foundation beneath your chosen upholstery. Add optional drawers in the Storage tab.</p></div>');
    panels.push({key:'base',title:'Base',panel:$base});
    panels.forEach(function(item) {
      if (!item.panel.length) return;
      var id = 'DivanPanel-' + item.key;
      var tabId = 'DivanTab-' + item.key;
      var $tab = $('<button type="button" role="tab"><svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+paths[item.key]+'</svg><span></span><small></small></button>');
      $tab.attr({id:tabId,'aria-controls':id,'aria-selected':'false',tabindex:'-1','data-divan-tab':item.key});
      $tab.find('span').text(item.title);
      $config.find('.lmb-divan-tabs').append($tab);
      item.panel.addClass('lmb-divan-tab-panel').attr({id:id,role:'tabpanel','aria-labelledby':tabId,'data-divan-panel':item.key,hidden:true}).appendTo($config);
      item.panel.find('>h3').attr({tabindex:'-1','aria-hidden':'true'}).removeAttr('role');
      $tab.on('click',function(){openDivanTab(item.key);});
    });
    $config.css('--dv-tab-count', $config.find('[role=tab]').length);
    $config.find('[role=tab]').on('keydown',function(e){
      var $tabs = $config.find('[role=tab]'), index = $tabs.index(this);
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      e.preventDefault();
      if(e.key==='Home')index=0;else if(e.key==='End')index=$tabs.length-1;else index=(index+(e.key==='ArrowRight'?1:-1)+$tabs.length)%$tabs.length;
      $tabs.eq(index).trigger('click').trigger('focus');
    });
    // Honour variant links; otherwise start with Single, the included headboard and no drawers.
    var linkedId = new URLSearchParams(window.location.search).get('variant');
    var data = getProductVariantsData();
    var linked = linkedId && data.variants.find(function(v){return String(v.id)===linkedId;});
    [$size,$headboard,$storage].forEach(function($panel){
      if(!$panel.length || $panel.find('input[type=radio]:checked').length) return;
      var $radios = $panel.find('input[type=radio]:not(:disabled)');
      var pos = Number($radios.first().attr('data-option-position'));
      var wanted = linked && pos ? linked['option'+pos] : ($panel.is($size) ? 'Single (3FT)' : $panel.is($headboard) ? '24"' : 'No Storage');
      var $chosen = $radios.filter(function(){return ($(this).attr('data-option-value') || $(this).attr('data-name'))===wanted;}).first();
      if(!$chosen.length) $chosen=$radios.first();
      $chosen.prop('checked',true);
    });
    openDivanTab('size');
    filterStorageOptions();
    updateDivanTabLabels();
  }

  function openDivanTab(key) {
    var $root=$('.product-option-main--divan');
    $root.find('[data-divan-tab]').each(function(){var active=$(this).attr('data-divan-tab')===key;$(this).attr({'aria-selected':String(active),tabindex:active?'0':'-1'});});
    $root.find('[data-divan-panel]').each(function(){$(this).prop('hidden',$(this).attr('data-divan-panel')!==key);});
  }

  function updateDivanTabLabels() {
    $('.product-option-main--divan [data-divan-tab]').each(function(){
      var key=$(this).attr('data-divan-tab');
      var $panel=$('.product-option-main--divan [data-divan-panel="'+key+'"]');
      var $input=$panel.find('input[type=radio]:checked').first();
      var label=$input.attr('data-name') || 'Choose';
      if(key==='base')label='Reinforced • Included';
      if(key==='headboard' && $panel.attr('data-fixed-headboard')==='54')label='54″ • Included';
      if(key==='headboard' && label==='24"')label='Free 24″ Headboard';
      if(key==='headboard' && label==='54"')label='54″ Floorstanding';
      $(this).find('small').text(label);
    });
  }


  function setupBedConfigurator() {
    $('.product-option-main--guided:not(.product-option-main--divan):not(.product-option-main--sofa)').each(function (rootIndex) {
      var $root = $(this), $list = $root.find('.product-options-list');
      var labelNode = $root.find('[data-bed-config-labels]')[0];
      if (!labelNode || $root.find('.lmb-bed-config').length) return;
      var labels = JSON.parse(labelNode.textContent);
      var definitions = [
        {key:'size', selector:'.product-option--size'},
        {key:'colour', selector:'.product-option--custom-fabric, .product-option--colour'},
        {key:'storage', selector:'.product-option--storage, .product-option--maximise-your-storage-space, .product-option--your-bed-base'},
        {key:'rails', selector:'.product-option--safety-side-rails'},
        {key:'tv', selector:'.product-option--upgrade-to-a-tv-bed'},
        {key:'bedroom', selector:'.product-option--change-your-bedroom-look'}
      ];
      var steps = definitions.map(function (step) {
        step.panel = $list.children(step.selector).first();
        return step;
      }).filter(function (step) { return step.panel.length; });
      if (steps.length < 2) return;
      var $config = $('<div class="lmb-bed-config"><div class="lmb-bed-tabs" role="tablist"></div><div class="lmb-bed-progress" role="status"></div><div class="lmb-bed-navigation"><button type="button" data-bed-back></button><button type="button" data-bed-next></button></div><details class="lmb-bed-summary"><summary></summary><div class="lmb-bed-summary__rows"></div></details></div>');
      $config.data({labels:labels, steps:steps});
      $config.find('[role=tablist]').attr('aria-label', labels.navigation);
      $config.find('[role=tablist]').css('--bed-step-count', steps.length);
      $config.find('[data-bed-back]').text(labels.back);
      $config.find('.lmb-bed-summary>summary').text(labels.summary);
      $config.prependTo($list);
      steps.forEach(function (step, index) {
        var panelId = 'BedPanel-' + rootIndex + '-' + step.key, tabId = 'BedTab-' + rootIndex + '-' + step.key;
        var $tab = $('<button type="button" role="tab"><span class="lmb-bed-tab__number" aria-hidden="true"></span><span class="lmb-bed-tab__name"></span></button>');
        $tab.attr({id:tabId, 'aria-controls':panelId, 'aria-selected':'false', tabindex:'-1', 'data-bed-tab':step.key});
        $tab.find('.lmb-bed-tab__number').text(index + 1);
        $tab.find('.lmb-bed-tab__name').text(labels[step.key]);
        $config.find('[role=tablist]').append($tab);
        step.panel.next('hr').remove();
        step.panel.addClass('lmb-bed-step-panel').attr({id:panelId, role:'tabpanel', 'aria-labelledby':tabId, 'data-bed-panel':step.key, hidden:true});
        step.panel.insertBefore($config.find('.lmb-bed-navigation'));
        step.panel.children('h3').removeAttr('role tabindex aria-expanded aria-controls');
        if (step.key === 'bedroom') step.panel.find('.lmb-option-header__copy strong').first().text(labels.bedroom);
        var $row = $('<div class="lmb-bed-summary__row"><span></span><strong></strong><button type="button"></button></div>');
        $row.attr('data-bed-summary',step.key).find('span').text(labels[step.key]);
        $row.find('button').text(labels.edit).attr('aria-label', labels.edit + ' ' + labels[step.key]).on('click', function () { openBedStep($config, step.key, true); });
        $config.find('.lmb-bed-summary__rows').append($row);
        $tab.on('click', function () { openBedStep($config, step.key); });
      });
      $config.find('[role=tab]').on('keydown', function (event) {
        var $tabs = $config.find('[role=tab]'), index = $tabs.index(this);
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        index = event.key === 'Home' ? 0 : event.key === 'End' ? $tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + $tabs.length) % $tabs.length;
        $tabs.eq(index).trigger('click').trigger('focus');
      });
      $config.find('[data-bed-back]').on('click', function () {
        var index = $config.data('activeIndex');
        if (index > 0) openBedStep($config, steps[index - 1].key, true);
      });
      $config.find('[data-bed-next]').on('click', function () {
        var index = $config.data('activeIndex');
        if (index < steps.length - 1) {
          openBedStep($config, steps[index + 1].key, true);
        } else {
          $config.attr('data-reviewing', 'true');
          steps.forEach(function (step) { step.panel.prop('hidden', true).children('.product-option-values').removeClass('active'); });
          $config.find('.lmb-bed-tabs,.lmb-bed-progress,.lmb-bed-navigation').prop('hidden', true);
          $config.find('.lmb-bed-summary').prop('open', true);
          $config.find('.lmb-bed-summary>summary').trigger('focus');
          $config.find('.lmb-bed-summary')[0].scrollIntoView({block:'start'});
        }
      });
      openBedStep($config, steps[0].key);
    });
  }

  function openBedStep($config, key, focus) {
    var steps = $config.data('steps');
    var index = steps.findIndex(function (step) { return step.key === key; });
    if (index < 0) return;
    $config.removeAttr('data-reviewing');
    $config.find('.lmb-bed-tabs,.lmb-bed-progress,.lmb-bed-navigation').prop('hidden', false);
    $config.find('.lmb-bed-summary').prop('open', false);
    $config.data('activeIndex', index);
    $config.find('[data-bed-tab]').each(function () {
      var active = $(this).attr('data-bed-tab') === key;
      $(this).attr({'aria-selected':String(active), tabindex:active ? '0' : '-1'});
    });
    steps.forEach(function (step) {
      var active = step.key === key;
      step.panel.prop('hidden', !active).children('.product-option-values').toggleClass('active', active);
    });
    $config.find('[data-bed-back]').prop('hidden', index === 0);
    updateBedStepLabels();
    if (focus) {
      var $tab = $config.find('[data-bed-tab="' + key + '"]');
      $tab.trigger('focus');
      $config[0].scrollIntoView({block:'nearest'});
    }
  }

  function updateBedStepLabels() {
    $('.lmb-bed-config').each(function () {
      var $config = $(this), labels = $config.data('labels'), steps = $config.data('steps');
      var index = $config.data('activeIndex');
      if (index === undefined) return;
      steps.forEach(function (step) {
        var $selected = step.panel.find('.option-value input[type=radio]:checked').first();
        var name = $selected.attr('data-name') || $selected.attr('data-option-value') || $selected.val();
        var $groups = step.panel.find('[data-luma-ring-group]');
        var complete = !!$selected.length;
        if ($groups.length) {
          complete = $groups.get().every(function (group) { return $(group).find('input[type=radio]:checked:not(:disabled)').length > 0; });
          name = $groups.get().map(function (group) { var $group = $(group); return $group.attr('data-ring-title') + ': ' + ($group.find('input:checked').attr('data-name') || labels.unselected); }).join(' · ');
        }
        $config.find('[data-bed-tab="' + step.key + '"]').toggleClass('is-complete', complete);
        $config.find('[data-bed-summary="' + step.key + '"] strong').text(name || (step.key === 'bedroom' ? labels.optional : labels.unselected));
      });
      var active = steps[index], selected = active.panel.find('.option-value input[type=radio]:checked').length;
      var $activeRingGroups = active.panel.find('[data-luma-ring-group]');
      if ($activeRingGroups.length) selected = $activeRingGroups.get().every(function (group) { return $(group).find('input[type=radio]:checked:not(:disabled)').length > 0; });
      var optional = active.panel.find('.option-value input[data-name="No Thanks"]').length > 0;
      $config.find('.lmb-bed-progress').text(labels.step.replace('__CURRENT__', index + 1).replace('__TOTAL__', steps.length));
      $config.find('[data-bed-next]').prop('disabled', !selected && !optional).text(index === steps.length - 1 ? labels.review : labels.continue);
    });
  }

  // SECTION 10: EVENT BINDING & INITIALIZATION
  // =====================================================

  // Accessible, single-open accordion keeps the choice journey simple.
  $('.product-option h3')
    .attr({ role: 'button', tabindex: '0', 'aria-expanded': 'false' })
    .on('click', function (e) {
    e.preventDefault();
    var $heading = $(this);
    var $section = $heading.closest('.product-option');
    if ($section.is('.lmb-divan-tab-panel, .lmb-bed-step-panel')) return;
    var shouldOpen = !$section.find('.product-option-values').hasClass('active');

    $('.product-option-values').removeClass('active');
    $('.product-option h3').attr('aria-expanded', 'false');
    $('.product-option .icon-accordion').removeClass('rotated');

    if (shouldOpen) {
      $section.find('.product-option-values').addClass('active');
      $heading.attr('aria-expanded', 'true');
      $heading.find('.icon-accordion').addClass('rotated');
    }
  })
    .on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });

  // Fabric type filtering
  setupFabricPickers();

  // All radio changes → recalculate prices
  $('.product-option-main').on('change', 'input[type="radio"]', function () {
    if ($(this).closest('.product-option-main--divan').length) filterStorageOptions();
    if ($(this).closest('.product-option--safety-side-rails').length) applyMattressFilters();
    updateVariantPrices();
    clearErrors();

    // If size changed, re-filter mattress and storage
    var optionPos = $(this).data('option-position');
    if (optionPos == 1 || $(this).attr('name') === 'option-1') {
      filterMattressBySize();
      filterStorageOptions();
      filterTvOptions();
      // Recalculate after filtering (options may have been deselected)
      updateVariantPrices();
    }
  });

  // Add-to-cart button
  $(document).on('change', 'select[name="assembly_options"]', updateVariantPrices);
  $(document).on('click', '.add-to-cart-btn', handleAddToCart);

  setupBedConfigurator();
  setupDivanConfigurator();

  // Initial mattress size filtering
  filterMattressBySize();
  filterTvOptions();

  // Initial calculations
  setTimeout(function () {
    filterStorageOptions();
    updateVariantPrices();
  }, 100);

  // Open first accordion by default
  var $firstOption = $('.product-option:first-child').not('.product-option--custom-fabric, .lmb-divan-tab-panel, .lmb-bed-step-panel');
  $firstOption.find('.product-option-values').addClass('active');
  $firstOption.find('h3').attr('aria-expanded', 'true');
  $firstOption.find('.icon-accordion').addClass('rotated');
  $('.product-option--custom-fabric .product-option-values').removeClass('active');
  $('.product-option--custom-fabric > h3').attr('aria-expanded', 'false');
  $('.product-option--custom-fabric .icon-accordion').removeClass('rotated');
});







